define('TescoMobile_Esim/js/view/catalog/product/esim',['jquery', 'uiElement', 'Magento_Ui/js/modal/modal'], function ($, Element, modal) {
  'use strict';

  return Element.extend({
    defaults: {
      modalContent: '',
      modalWindow: null
    },
    openEsimModal: function () {
      $(this.modalWindow).modal('openModal');
    },
    createModal: function (element) {
      this.modalWindow = element;
      modal({
        modalClass: 'pdp-esim-modal',
        responsive: true,
        innerScroll: true,
        type: 'popup',
        buttons: [],
        clickableOverlay: true
      }, $(this.modalWindow));
    }
  });
});

